import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootReducer} from 'appRedux/reducers';
import {getRefreshToken, getToken} from 'services/localStorage';

export default function useAuthTokens() {
    const [token, setToken] = useState(() => getToken());
    const [refreshToken, setRefreshToken] = useState(() => getRefreshToken());

    const {
        auth: {authData},
    } = useSelector<RootReducer>(state => state) as RootReducer;

    useEffect(() => {
        setToken(getToken());
        setRefreshToken(getRefreshToken());
    }, [authData]);

    return {token, refreshToken};
}
